<div class="bottom-navbar">
  <div class="nav-button whats" (click)="navWhatsapp()">
    <fa-icon [icon]="faWhatsapp" size="2x"></fa-icon>
  </div>

  <div class="nav-button cart" (click)="navCart()">
    <fa-icon [icon]="faCartShopping" size="2x"></fa-icon>
    @if (cartServ.n_items > 0) {
      <span class="badge rounded-pill bg-danger cart-badge">
        {{ cartServ.n_items }}
      </span>
    }
  </div>

  <div class="nav-button orders" (click)="navOrders()">
    <fa-icon [icon]="faClipboardList" size="2x"></fa-icon>
    @if (ooServ.n_active_items > 0) {
      <span class="badge rounded-pill bg-danger cart-badge">
        {{ ooServ.n_active_items }}
      </span>
    }
  </div>
</div>